import type { FaireProductEntity } from "../../entity_types/product";

export const p_gyac6k8y9w: FaireProductEntity = {
  token: "p_gyac6k8y9w",
  type: "product",
  name: "Hot Girls Lift Weights Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/2719f56bcb92aaecd51df24532dee412ab833c44b370fbe6b5a476a55e594551.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/32c9905e4ec41ee9199e3e11254ebf1e893bb84c3c33b500629c8987cdb018c7.jpeg",
    "https://cdn.faire.com/fastly/3fca8e0c66e885551d15d2d8c01e6056d35d86ba52f2c695eee36333e5eb3f3e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/ce11970287afb28599201ebe506df9a6d89fe920b905a8a52593ff8302247449.jpeg",
    "https://cdn.faire.com/fastly/91534d984aaf29f4b4dcd0595b828b910a6b326895672def7502dc8ffea01590.jpeg",
    "https://cdn.faire.com/fastly/8fa00fe9ae3cb728662861af2d38d0600bbc0cd28a5dd93ef4ea687c9a8826d0.jpeg",
    "https://cdn.faire.com/fastly/30b68e11cc9aad446db342b27e74bbef494545caec2b441ef9cb047e04837392.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the girls that lift weights and drop jaws - these socks are for all the strong hotties out there. 🏋️ 😍\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:25.315Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
